/**
 *
 * 判断是否是微信进入 如果是微信进入 则进行认证 跳转填报页面
 * 如果是企业微信进入 提示错误
 */
import {URL_ROOT} from '@/env';
import React, {useEffect, useState} from 'react';
import {
    Checkbox,
    Radio,
    Button,
    Spin,
    Form,
    Avatar,
    Divider,
    Tag,
    message,
    Result,
    Image,
} from 'antd';
import {SendOutlined, ArrowDownOutlined} from '@/icons';
import styles from './index.module.less';
import {
    getAgreementInfo,
    openCutsomerInfo,
    openWxToken,
    saveAgreementInfo,
    updateAgreementInfo,
} from '@/api/open';
import useTitle from '@/hook/useTitle';

let url = URL_ROOT + '/wx/mobile/agreement';
const appId = 'wx4f0b6567389de3da';
export default function WxAuth() {
    useTitle('授权');
    useEffect(() => {
        initData();
    }, []);
    const [isWecom, setIsWecom] = useState(false);

    function initData() {
        if (navigator.userAgent.indexOf('wxwork') != -1) {
            // 企业微信
            setIsWecom(true);
        } else {
            setIsWecom(false);
            // 微信进入，走验证流程
            let externalUserId = window.location.href.split('=')[2];
            let unionId = window.location.href.split('=')[1].split('&')[0];
            url = encodeURI(url + `?unionId=${unionId}&externalUserId=${externalUserId}`);
            auth();
        }
    }

    function auth() {
        window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect&forcePopup=true`;
    }

    function renderAuthHtml() {
        return (
            <div className={styles.auth}>
                获取用户信息中，如无跳转，请点击下方按钮...
                <div className={styles.icon}>
                    <Image src={require('@/asset/arrow-blue.gif').default} width={20}></Image>
                    <Image src={require('@/asset/arrow-blue.gif').default} width={20}></Image>
                    <Image src={require('@/asset/arrow-blue.gif').default} width={20}></Image>
                </div>
            </div>
        );
    }

    function renderWecom() {
        return (
            <Result
                status="404"
                style={{marginTop: 20, backgroundColor: 'transparent'}}
                title=""
                subTitle="如需查看知情同意签署状态，请点击聊天框上方【知情同意】按钮"
            />
        );
    }

    return (
        <div style={{margin: '10px 0', height: '100vh'}}>
            <div>{isWecom ? renderWecom() : renderAuthHtml()}</div>
        </div>
    );
}
